/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../base.component';
import { Component } from '@angular/core';
import { ModalService, UserService } from '../../services';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-force-logout',
    templateUrl: './forceLogout.component.html',
    styleUrls: ['./forceLogout.component.scss']
})

export class ForceLogoutComponent extends BaseComponent {
    /**
     * Countdown timer for force logout modal.
     */
    public countdownTimer: number = 10;

    constructor(
        private userService: UserService,
        private modalService: ModalService,
    ) {
        super();

        this.setUpModalSubscriber();
    }

    /**
     * Log out now button.
     */
    public logOutNow(): void {
        this.userService.logout();
    }

    /**
     * Set up modal subscriber.
     * @private
     */
    private setUpModalSubscriber(): void {
        this.modalService.openParentModalEmitter
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                next: (modal: any): void => {
                    if (modal.id === 'logoutCountdown') {
                        this.startCountdownTimer();
                        const timerId = setTimeout((): void => {
                            clearTimeout(timerId);
                        }, 250);
                    }
                }
            });
    }

    /**
     * Start countdown timer.
     * @private
     */
    private startCountdownTimer(): void {
        const startCountdown = setInterval((): void => {
            this.countdownTimer--;
            if (this.countdownTimer === 0) {
                clearInterval(startCountdown);
                this.userService.logout();
            }
        }, 1000);
    }
}
